import EzController from 'controllers/ez-base-controller';
import { featureEnabled } from 'lib/helpers';
import {
  sendTrackingEvent,
  trackCompleteEvent,
  findCategoryByElement,
  NEW_ANALYTICS_FEATURE,
} from 'components/analytics/conversions/tracking';
import { JOIN_PRO_CLICK, JOIN_PRO_COMPLETE } from 'components/analytics/conversions/constants/actions';

export default class UnlockVecteezyController extends EzController {
  track() {
    if (!featureEnabled(NEW_ANALYTICS_FEATURE)) return;

    const category = findCategoryByElement(this.element);

    sendTrackingEvent({
      element: this.element,
      data: {
        action: JOIN_PRO_CLICK,
        category,
      },
    });

    trackCompleteEvent({
      action: JOIN_PRO_COMPLETE,
      category,
    });
  }
}
